/**
 * TOAST NOTIFICATION STATE
 *
 * A global notification system. Any component in the app can call
 * toastState.success('Saved!') and a toast will appear in the top-right corner.
 *
 * WHY Runes? $state makes the toast array reactive. When we push/remove
 * a toast, every component reading `toastState.toasts` auto-updates.
 */
let toasts = $state([]);
let nextId = 0;
function addToast(type, message, durationMs = 4000) {
    const id = nextId++;
    // Push new toast into the reactive array
    toasts = [...toasts, { id, type, message }];
    // Auto-remove after duration (no manual dismiss needed)
    setTimeout(() => {
        removeToast(id);
    }, durationMs);
}
function removeToast(id) {
    toasts = toasts.filter((t) => t.id !== id);
}
export const toastState = {
    get toasts() { return toasts; },
    success: (msg) => addToast('success', msg),
    error: (msg) => addToast('error', msg, 6000), // Errors stay longer
    warning: (msg) => addToast('warning', msg),
    info: (msg) => addToast('info', msg),
    remove: removeToast,
};
//# sourceMappingURL=toast.state.svelte.js.map